(function () {
  function initFaqs(container) {
    if (!container) return;

    const allowMultiple = container.dataset.allowMultiple === 'true';
    const items = container.querySelectorAll('.ctr-faqs__item');

    items.forEach((item) => {
      const header = item.querySelector('.ctr-faqs__item-header');
      const body = item.querySelector('.ctr-faqs__item-body');
      if (!header || !body) return;

      if (item.dataset.openDefault === 'true') {
        openItem(item, body, false);
      }

      header.addEventListener('click', () => {
        const isOpen = item.classList.contains('is-open');

        if (!allowMultiple && !isOpen) {
          items.forEach((otherItem) => {
            if (otherItem !== item && otherItem.classList.contains('is-open')) {
              const otherBody = otherItem.querySelector('.ctr-faqs__item-body');
              closeItem(otherItem, otherBody, true);
            }
          });
        }

        if (isOpen) {
          closeItem(item, body, true);
        } else {
          openItem(item, body, true);
        }
      });
    });
  }

  function openItem(item, body, animate) {
    item.classList.add('is-open');
    item.querySelector('.ctr-faqs__item-header')
      .setAttribute('aria-expanded', 'true');

    if (animate) {
      const inner = body.querySelector('.ctr-faqs__item-body-inner');
      const targetHeight = inner.scrollHeight;
      body.style.height = '0px';
      body.offsetHeight;
      body.style.height = targetHeight + 'px';

      const onEnd = () => {
        body.style.height = 'auto';
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    } else {
      body.style.height = 'auto';
    }
  }

  function closeItem(item, body, animate) {
    item.querySelector('.ctr-faqs__item-header')
      .setAttribute('aria-expanded', 'false');

    if (animate) {
      body.style.height = body.scrollHeight + 'px';
      body.offsetHeight;
      body.style.height = '0px';

      const onEnd = () => {
        item.classList.remove('is-open');
        body.removeEventListener('transitionend', onEnd);
      };
      body.addEventListener('transitionend', onEnd);
    } else {
      body.style.height = '0px';
      item.classList.remove('is-open');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.ctr-faqs__items').forEach(initFaqs);
  });

  if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (e) => {
      const container = e.target.querySelector('.ctr-faqs__items');
      if (container) initFaqs(container);
    });
  }
})();
